export default "<li><a href=\"\"></a></li>\n"